import { Row, Col, Card } from 'react-bootstrap';

const ErrorPage = () => {
  return (
    <>
      <h1 className="mt-4 text-center justify-content-center w-100">An Error has occurred</h1>
      <Row className="mt-5 justify-content-center">
        <Col md={8} style={{ maxWidth: 600 }}>
          <Card className="p-3">
            <p>Please try again later</p>
            <p>We apologize for the inconvenience</p>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ErrorPage;
